/* MIRIJANA — Sonnenreise homepage motion.
   Scroll progress, reveal-on-scroll, parallax and a light pointer tilt.
   Everything is fail-safe: the hidden state is only applied via CSS classes
   that this file always resolves, plus a timed safety net, so a broken
   observer can never leave the page invisible. */
(function () {
  try {
    // marks that the motion layer is alive; clip-path reveals key off this so a
    // blocked script can never leave content hidden
    document.documentElement.classList.add('mj-js');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

    /* ---------- reveal ---------- */
    var hasIO = 'IntersectionObserver' in window;
    var io = hasIO ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }) : null;

    function observe() {
      var els = $$('.rv:not(.in)');
      if (!hasIO) { els.forEach(function (el) { el.classList.add('in'); }); return; }
      els.forEach(function (el) { io.observe(el); });
      // safety net — anything already on screen shows even if a callback is missed
      setTimeout(function () {
        $$('.rv:not(.in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < (innerHeight || 900) && r.bottom > 0) el.classList.add('in');
        });
      }, 1200);
    }

    /* ---------- stagger siblings inside a grid ---------- */
    ['.mjfeat .panel', '.mjcat .grid', '.mjprod .grid'].forEach(function (sel) {
      var wrap = document.querySelector(sel);
      if (!wrap) return;
      $$('.rv', wrap).forEach(function (el, i) {
        if (!el.style.transitionDelay) el.style.transitionDelay = (i % 6) * 70 + 'ms';
      });
    });


    /* ---------- drifting light motes ---------- */
    function motes(host, count) {
      if (!host || reduce) return;
      var layer = host.querySelector(':scope > .mjmote-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'mjmote-layer';
        host.appendChild(layer);
      }
      var frag = document.createDocumentFragment();
      for (var i = 0; i < count; i++) {
        var m = document.createElement('span');
        m.className = 'mjmote';
        var size = (2 + Math.random() * 4.5).toFixed(1);
        m.style.width = m.style.height = size + 'px';
        m.style.left = (Math.random() * 100).toFixed(2) + '%';
        m.style.top = (55 + Math.random() * 45).toFixed(2) + '%';
        m.style.setProperty('--dx', (Math.random() * 70 - 35).toFixed(0) + 'px');
        m.style.animationDuration = (15 + Math.random() * 17).toFixed(1) + 's';
        m.style.animationDelay = (-Math.random() * 28).toFixed(1) + 's';
        frag.appendChild(m);
      }
      layer.appendChild(frag);
    }

    /* ---------- magnetic buttons ---------- */
    function magnetise() {
      if (reduce || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
      document.addEventListener('pointermove', function (e) {
        var b = e.target.closest && e.target.closest('.mjbtn');
        if (!b) return;
        var r = b.getBoundingClientRect();
        var mx = (e.clientX - r.left - r.width / 2) / r.width;
        var my = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (mx * 7).toFixed(1) + 'px,' + (my * 5 - 3).toFixed(1) + 'px)';
      }, { passive: true });
      document.addEventListener('pointerout', function (e) {
        var b = e.target.closest && e.target.closest('.mjbtn');
        if (b && !b.contains(e.relatedTarget)) b.style.transform = '';
      }, { passive: true });
    }

    /* ---------- scroll: progress + parallax ---------- */
    var bar = document.querySelector('.mjprogress i');
    var parItems = $$('[data-par]');
    var ticking = false;

    function frame() {
      ticking = false;
      var doc = document.documentElement;
      var y = window.scrollY || doc.scrollTop || 0;
      var max = doc.scrollHeight - doc.clientHeight;
      var prog = max > 0 ? Math.min(1, y / max) : 0;
      if (bar) bar.style.transform = 'scaleX(' + prog + ')';
      // exposed so CSS can drive scroll-linked effects (hero depth, etc.)
      doc.style.setProperty('--mj-scroll', (Math.min(1, y / (innerHeight || 900))).toFixed(3));
      if (reduce) return;
      var vh = innerHeight || doc.clientHeight;
      for (var i = 0; i < parItems.length; i++) {
        var el = parItems[i];
        if (el.offsetParent === null) continue;
        var r = el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > vh + 240) continue;
        var p = (r.top + r.height / 2 - vh / 2) / vh;   // -1 … 1 across the viewport
        el.style.transform = 'translate3d(0,' + (p * parseFloat(el.dataset.par) * 190).toFixed(1) + 'px,0)';
      }
    }
    addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }, { passive: true });
    addEventListener('resize', function () { parItems = $$('[data-par]'); frame(); });

    /* ---------- pointer tilt, category tiles only ----------
       Deliberately NOT on .pcard: a perspective rotate foreshortens the card,
       so its apparent width and the gap beside it change on interaction. */
    if (!reduce && matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('pointermove', function (e) {
        var c = e.target.closest && e.target.closest('.catcard');
        if (!c || !c.classList.contains('in')) return;
        var r = c.getBoundingClientRect();
        var rx = ((e.clientY - r.top) / r.height - 0.5) * -5;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 5;
        c.style.transform = 'perspective(1000px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' +
          ry.toFixed(2) + 'deg) translateY(-8px)';
      }, { passive: true });
      document.addEventListener('pointerout', function (e) {
        var c = e.target.closest && e.target.closest('.catcard');
        if (c && !c.contains(e.relatedTarget)) c.style.transform = '';
      }, { passive: true });
    }

    function start() {
      observe();
      motes(document.querySelector('.mjhero'), innerWidth < 700 ? 10 : 18);
      motes(document.querySelector('.mjcat .panel'), innerWidth < 700 ? 6 : 10);
      var hero = document.querySelector('.mjhero');
      if (hero && !reduce && !hero.querySelector('.mjaura')) {
        var aura = document.createElement('div');
        aura.className = 'mjaura';
        hero.insertBefore(aura, hero.firstChild);
      }
      magnetise();
      frame();
      // let the hero headline play once styles have settled
      var copy = document.querySelector('.mjhero .copy');
      if (copy) requestAnimationFrame(function () {
        requestAnimationFrame(function () { copy.classList.add('in'); });
      });
    }

    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start);
  } catch (e) {
    // never break the storefront for an animation
    Array.prototype.forEach.call(document.querySelectorAll('.rv'), function (el) {
      el.classList.add('in');
    });
  }
})();
